// extracted by mini-css-extract-plugin
export default {"SpinnerSection":"Spinner_SpinnerSection__AK+Mc","Spinner":"Spinner_Spinner__dieAo","spin":"Spinner_spin__+It8j","LoadingMessage":"Spinner_LoadingMessage__YpuN-"};